<script>
  //import { formatnumber } from './Utils.svelte';
  // export let target;
  export let current_target;
  export let current;
  export let unterer_text;
  export let circle_size = 35;
  export let without_target = false;
  export let replace_text = "";
  export let do_not_format = false;
  export let digits = 2;
  export let target_muss_darunter_sein = false;
  export let replace_current = false;
  export let ampel_ganz_links = false;
  export let add_percentage_at_target = false;
  export let add_euro_at_target = false;
  export let image = false;
  export let image_height = 8;
  export let bottom = 10;
  export let ampel_weg = false;

  var unitlist = ["", "k", "m", "g"];

  function replace_dot(number) {
    var s = number.toString();
    s = s.replace(".", ",");
    return s;
  }

  function formatnumber(number) {
    let sign = Math.sign(number);
    let unit = 0;

    if (!isFinite(number)) {
      return 0;
    }

    if (number < 1000 && number >= 0) {
      return number.toFixed(1);
    }

    while (Math.abs(number) > 1000) {
      unit = unit + 1;
      number = Math.floor(Math.abs(number) / 100) / 10;
    }
    return sign * Math.abs(number) + unitlist[unit];
  }
</script>

<div
  class="row"
  style="position:relative; background-color: #f2f2f2; height:120px; margin-top: 0px; margin-bottom: 0px; margin-left: 0px; margin-right: 0px;"
>
  <div class="col-12">
    <div class="row center">
      {#if !without_target}
        <p class="vertical-center1" style="color:#4eb3cf">
          {#if current_target}
            Target: {do_not_format
              ? replace_dot(current_target.toFixed(digits)).toString() +
                (add_percentage_at_target ? "%" : "") +
                (add_euro_at_target ? "€" : "")
              : replace_dot(formatnumber(current_target)).toString() +
                (add_percentage_at_target ? "%" : "") +
                (add_euro_at_target ? "€" : "")}
          {/if}
        </p>
      {:else}
        <p class="vertical-center1" style="">{replace_text}</p>
      {/if}
    </div>
    <div class="row center">
      <p class="vertical-center2" style="font-weight:500; font-size: 26px;">
        {#if !replace_current}
          {do_not_format
            ? replace_dot(current.toFixed(digits)).toString() + (add_percentage_at_target ? "%" : "") + (add_euro_at_target ? "€" : "")
            : replace_dot(formatnumber(current)).toString() + (add_percentage_at_target ? "%" : "") + (add_euro_at_target ? "€" : "")}
        {:else}
          {do_not_format
            ? replace_dot(replace_current.toFixed(digits)).toString() +
              (add_percentage_at_target ? "%" : "") +
              (add_euro_at_target ? "€" : "")
            : replace_dot(formatnumber(replace_current)).toString() +
              (add_percentage_at_target ? "%" : "") +
              (add_euro_at_target ? "€" : "")}
        {/if}
      </p>
    </div>
    <div class="row center">
      <p class="vertical-center3" style="">{unterer_text}</p>
    </div>

    <div class="row center">
      <div class={!ampel_ganz_links ? "ampel-position" : ""}>
        <span class="dot" style="height:{circle_size}px; width:{circle_size}px;" />
      </div>
      {#if !ampel_weg}
        {#if !target_muss_darunter_sein}
          {#if current_target < current}
            <div class={!ampel_ganz_links ? "ampel-position" : "ampel-position-ganz-links"}><span class="dot-innen-gruen" /></div>
          {:else}
            <div class={!ampel_ganz_links ? "ampel-position" : "ampel-position-ganz-links"}><span class="dot-innen-orange" /></div>
          {/if}
        {:else if current_target > current}
          <div class={!ampel_ganz_links ? "ampel-position" : "ampel-position-ganz-links"}><span class="dot-innen-gruen" /></div>
        {:else}
          <div class={!ampel_ganz_links ? "ampel-position" : "ampel-position-ganz-links"}><span class="dot-innen-orange" /></div>
        {/if}
      {/if}
    </div>
  </div>
  {#if image}
    <img
      class="funnel center-image"
      style="width:40px;bottom: {bottom}%; height: {image_height}px;"
      src="/static/img/icons/{image}"
      alt="background image"
    />
  {/if}
</div>

<style>
  .center {
    text-align: center;
  }

  .container {
    height: 30px;
    position: relative;
  }

  .center-image {
    margin: 0;
    position: absolute;

    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .ampel-position-ganz-links {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 41%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .ampel-position {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 20%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .vertical-center1 {
    margin: 0;
    position: absolute;
    top: 20%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .vertical-center2 {
    margin: 0;
    position: absolute;
    top: 45%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .vertical-center3 {
    margin: 0;
    position: absolute;
    top: 70%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .dot-innen-gruen {
    height: 20px;
    width: 20px;
    background-color: #c1e010;
    border-radius: 50%;
    display: inline-block;
    border-width: 0.25pt;
    border-style: solid;
    border-color: white;
  }

  .dot-innen-orange {
    height: 20px;
    width: 20px;
    background-color: #ffc000;
    border-radius: 50%;
    display: inline-block;
    border-width: 0.25pt;
    border-style: solid;
    border-color: white;
  }

  .dot {
    /*height: 35px;
    width: 35px;
    background-color: #ffffff;
    border-radius: 50%;
    display: inline-block;*/
  }
</style>
